var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.populateStylingClasses(),on:{"click":_vm.restoreModal}},[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"minimised-text",attrs:{"title":_vm.modalTooltip},domProps:{"innerHTML":_vm._s(_vm.modalTitle)}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9248c22","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/home/_components/minimised-modal/minimised-modal.html
// module id = null
// module chunks = 